// localStorage flag that mirrors whether AuthContext currently has a user.
// Read synchronously at first render to avoid the blank-flash on the
// landing page while /auth/me is in flight. Not used for any auth
// decision — the server (httpOnly paysafi_token cookie) is the source
// of truth. Cleared whenever AuthContext resolves to a null user.
const KEY = "paysafi_has_session";

export function readSessionHint() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setSessionHint(present) {
  try {
    if (present) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    // private mode / quota / storage disabled — hint is best-effort
  }
}
